import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Page } from "../types";

type Params = {
  isActive: boolean;
  brandId: string;
  pageId: string;
};

export const updatePageStatus = async ({
  brandId,
  pageId,
  isActive,
}: Params) => {
  const collectionRef = collection(db, `brands/${brandId}/pages`);

  await updateDoc(doc(collectionRef, pageId), {
    isActive,
    updatedAt: new Date(),
  });

  const pageSnapshot = await getDoc(doc(collectionRef, pageId));

  return pageSnapshot.data() as Page;
};
